export default __webpack_public_path__ + "static/media/uploader-caresens-problem-2.f0397874.png";